import { cn } from '@/lib/utils';

/** Decorative beside the product name; the surrounding link supplies its label. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span className={cn('bg-foreground text-background inline-flex size-8 shrink-0 items-center justify-center rounded-lg', className)} aria-hidden="true">
      <svg viewBox="0 0 64 64" className="size-full fill-current" focusable="false">
        <use href="/brand/mark.svg#monogram" />
      </svg>
    </span>
  );
}
